var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showMinimalTracker
    ? _c("div", { staticClass: "order-tracker-minimal-container" }, [
        _c(
          "div",
          { staticClass: "icon-wrapper", class: _vm.styleIcon("ordering") },
          [
            _c("BaseIcon", {
              attrs: {
                editStroke: false,
                isCustom: true,
                icon: _vm.getIcon("ordering"),
                classNames: _vm.getClassNamesForIcon("ordering")
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "icon-label" }, [
              _vm._v(
                "\n\t\t\t" + _vm._s(_vm.getTrackerLabel("ordering")) + "\n\t\t"
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "icon-wrapper", class: _vm.styleIcon("placed") },
          [
            _c("BaseIcon", {
              attrs: {
                editStroke: false,
                isCustom: true,
                icon: _vm.getIcon("placed"),
                classNames: _vm.getClassNamesForIcon("placed")
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "icon-label" }, [
              _vm._v(
                "\n\t\t\t" + _vm._s(_vm.getTrackerLabel("placed")) + "\n\t\t"
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "icon-wrapper", class: _vm.styleIcon("making") },
          [
            _c("BaseIcon", {
              attrs: {
                editStroke: false,
                isCustom: true,
                icon: _vm.getIcon("making"),
                classNames: _vm.getClassNamesForIcon("making")
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "icon-label" }, [
              _vm._v(
                "\n\t\t\t" + _vm._s(_vm.getTrackerLabel("making")) + "\n\t\t"
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        !_vm.isOrderDelivery
          ? _c(
              "div",
              { staticClass: "icon-wrapper", class: _vm.styleIcon("pickup") },
              [
                _c("BaseIcon", {
                  attrs: {
                    editStroke: false,
                    isCustom: true,
                    icon: _vm.getIcon("pickup"),
                    classNames: _vm.getClassNamesForIcon("pickup")
                  }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "icon-label" }, [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.getTrackerLabel("pickup")) +
                      "\n\t\t"
                  )
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isOrderDelivery
          ? _c(
              "div",
              {
                staticClass: "icon-wrapper",
                class: _vm.styleIcon("delivering")
              },
              [
                _c("BaseIcon", {
                  attrs: {
                    editStroke: false,
                    isCustom: true,
                    icon: _vm.getIcon("delivering"),
                    classNames: _vm.getClassNamesForIcon("delivering")
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "icon-label" },
                  [
                    _vm.isStatusDelivering
                      ? [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.getTrackerLabel("delivering")) +
                              "\n\t\t\t"
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isStatusDelivering
                      ? [_vm._v("\n\t\t\t\tDelivered!\n\t\t\t")]
                      : _vm._e()
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bddc1028", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bddc1028","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order-confirmation/OrderTrackerMinimal.vue
// module id = null
// module chunks = 